import { ReactNode, createContext, useContext } from 'react';
import { DeclareNewDayContextType } from '../../interface/fo-dnd-interface';
import useDeclareNewDay from '../../../../hooks/useDeclareNewDay';

type Props = {
  children: ReactNode;
};

const DeclareNewDayContext = createContext<
  DeclareNewDayContextType | undefined
>(undefined);

export const useDeclareNewDayContext = () => {
  const context = useContext(DeclareNewDayContext);
  if (!context) {
    throw new Error(
      'useDeclareNewDayContext must be used within an DeclareNewDayProvider',
    );
  }
  return context;
};

export const DeclareNewDayProvider = ({ children }: Props) => {
  const {
    dndCheckList,
    totalTask,
    refreshList,
    isLoading,
    reservationList,
    checkOutList,
    checkInList,
    tariffList,
    blockList,
    vcdList,
    fipList,
    roomStatusUpdate,
    declareNewDay,
    roomTariffPost,
    roomUnblocking,
    forceLogout,
  } = useDeclareNewDay();

  return (
    <DeclareNewDayContext.Provider
      value={{
        dndCheckList,
        totalTask,
        refreshList,
        isLoading,
        reservationList,
        checkOutList,
        checkInList,
        tariffList,
        blockList,
        vcdList,
        fipList,
        roomStatusUpdate,
        declareNewDay,
        roomTariffPost,
        roomUnblocking,
        forceLogout,
      }}
    >
      {children}
    </DeclareNewDayContext.Provider>
  );
};
